export const getCompactMultiSelectMaxTagCount = (selectedValues) => (
  Array.isArray(selectedValues) && selectedValues.length > 1 ? 0 : 1
);

export const getCompactMultiSelectPlaceholder = (selectionType = 'items') => (
  (omittedValues) => `${omittedValues.length} ${selectionType} selected`
);
